import * as Sentry from "@sentry/tanstackstart-react"
import { QueryClient } from "@tanstack/react-query"
import { createRouter } from "@tanstack/react-router"
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query"
import { NotFound } from "./components/NotFound"
import { routeTree } from "./routeTree.gen"

export const getRouter = () => {
  // This should be created here, not globally
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 2, // 2 minutes
      },
    },
  })

  const router = createRouter({
    routeTree,
    context: {
      queryClient,
      authData: {
        user: null,
        token: null,
      },
      language: "nl",
    },
    defaultPreload: "intent",
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultNotFoundComponent: () => <NotFound />,
  })

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
    handleRedirects: true,
    wrapQueryClient: true,
  })

  // Initialize Sentry on the client side only (after router is created)
  if (!router.isServer && typeof window !== "undefined") {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
      sendDefaultPii: false,
      tracesSampleRate: parseFloat(
        (import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string | undefined) || "0.05",
      ),
      environment: (import.meta.env.VITE_VERCEL_TARGET_ENV as string | undefined) || "dev-local",
      enabled: import.meta.env.PROD,
      integrations: [
        Sentry.tanstackRouterBrowserTracingIntegration(router),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
        Sentry.consoleLoggingIntegration({ levels: ["error", "warn"] }),
        Sentry.zodErrorsIntegration(),
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })
  }

  return router
}
